document.addEventListener("DOMContentLoaded", function () {
  /*Recargue*/
  // Simular un retraso en la carga de la página
  setTimeout(function () {
    // Ocultar el indicador de carga
    document.getElementById("loader").classList.add("hidden");
    // Mostrar el contenido de la página
    document.getElementById("content").classList.remove("hidden");
    //Ocultar fondo semitransparente
    document.getElementById("carga").classList.add("hidden");
  }, sessionStorage.getItem("firstLoad") === "1" ? 0 : 2000);
  sessionStorage.setItem("firstLoad", "1");
});
